import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import heateroff from "../assets/heateroff.svg";
import heateron from "../assets/heateron.svg";
import Switch from "./switch";
import Form from "react-bootstrap/Form";
import chaletStore, { ChaletState } from "../state/chaletstore";


function RoomControlPanel() {
  const rooms = chaletStore(state=>state.data.rooms)
  const toggleHeater = chaletStore((state) => state.updateRoom)

  return (
    <Container fluid>
     <Row key='header' className="pb-3 headerrow">
      <Col key='1' className="col-3 justify-content-center">Room</Col>
      <Col key='2' className="col-2"></Col>
      <Col className="col-3">Target</Col>
      <Col className="col-3">Actual</Col>
      <Col className="col-1">Status</Col>
    </Row>
      {Object.values(rooms).map((room) => (
        <Row key={room.id}>
        <Col className="col-3">{room.name}</Col>
        <Col className="col-2">
        <Form>
            <Form.Check // prettier-ignore
              type="switch"
              checked={room.switch_state}
              onChange={(e) => toggleHeater(room.id,'setOnOff','onoff') }
            />
          </Form></Col>
        <Col className="col-3">{room.targetTemp}</Col>
        <Col className="col-3">{room.actualTemp}</Col>
        <Col className="col-1">
        {room.thermState == 'On' ? 
          (<img src={heateron} width={24} height={24} alt="Logo" />) :
          (<img src={heateroff} width={24} height={24} alt="Logo" />) 
        }

        </Col>
      </Row>
      ))}
    </Container>
  );
}

export default RoomControlPanel;
